import { Injectable } from '@angular/core'
import { TranCategoryKey } from '../models/transaction-metadata.model'
import { TRANSACTION_CREATE_DEFAULTS } from '../registry/catalogs/transaction-values.fixture'

/**
 * Seam between the Create/Edit Transaction modal and the *values* behind it.
 *
 * It used to carry a `sampleComparison()` too — a fabricated Prometheus column shown whenever the
 * edited row had no matched counterpart. That is gone with the fixture behind it: the comparison
 * side is filled by its own endpoint, and until then an empty column is the honest answer. See
 * `transaction-values.fixture.ts`.
 *
 * Value LISTS are not here either. A field's allowed values are served with the field, on the
 * metadata document's own `listValues` block, and the dialog reads them straight off it — see
 * `listOptionsOf` in `edit-transaction.projection.ts`.
 *
 * Separate from {@link TransactionMetadataSource} because the two swap out independently.
 */
export abstract class TransactionValueSource {
  /** Values a new transaction of this tran category opens with. */
  abstract createDefaults(
    tranCategory: TranCategoryKey,
  ): Readonly<Record<string, unknown>>
}

/** Reads what the checked-in fixture holds, which is currently nothing. */
@Injectable()
export class StaticTransactionValueService extends TransactionValueSource {
  /** A tran category with no authored seeds opens an empty draft rather than no draft at all — the
   * projection indexes this, so it must always be an object. */
  createDefaults(
    tranCategory: TranCategoryKey,
  ): Readonly<Record<string, unknown>> {
    return TRANSACTION_CREATE_DEFAULTS[tranCategory] ?? {}
  }
}
